import { signInWithRedirect } from 'aws-amplify/auth';
import React, { useEffect, useRef } from 'react';
import LoginDefaults from './login-defaults';

function SAMLSignIn({ authState }) {
  const hasRedirected = useRef(false);
  
  useEffect(() => {
    if (LoginDefaults && LoginDefaults.samlCheckDisabled) {
      return;
    }

    console.log('SAMLSignIn - authState:', authState, 'hasRedirected:', hasRedirected.current);

    if (authState === 'signIn' && !hasRedirected.current) {
      // Don't auto-login if user explicitly logged out
      if (localStorage.getItem('logged-out')) {
        return;
      }
      hasRedirected.current = true;
      console.log('Triggering signInWithRedirect...');
      const providerName = process.env.REACT_APP_COGNITO_PROVIDER_NAME;
      signInWithRedirect({ provider: { custom: providerName } });
    }
  }, [authState]);

  if (LoginDefaults && LoginDefaults.samlCheckDisabled) {
    return null;
  }

  if (authState === 'loading') {
    return <div>Loading...</div>;
  }

  return null;
}

export default SAMLSignIn;